import React, { useEffect, useRef } from 'react';
import ProgressBar from '../components/ProgressBar';
import QuestionRenderer from '../components/QuestionRenderer';


const QuestionnaireFlow = ({
    currentQuestion,
    initialAnswer,
    totalQuestions,
    activeVersion,
    onAnswer,
    onBack,
    onReselect, // Received
    onRestart, // Received
    loading
}) => {
    // Scroll to top when question changes
    const containerRef = useRef(null);

    useEffect(() => {
        if (containerRef.current) {
            containerRef.current.scrollTop = 0;
            // Also scroll window if needed?
            // window.scrollTo(0, 0); 
        }
    }, [currentQuestion]);

    if (loading) {
        return <div className="ae-loading">
            <div className="spinner"></div>
            <p>질문을 불러오는 중입니다...</p>
        </div>;
    }

    // Only the customer-facing `label` is allowed in the pill. The `name`
    // field is the internal version identifier ("Smart Pharmacy 2026 v0.1"
    // and friends) which customers don't recognize, so we never fall back
    // to it — if a questionnaire has no meaningful label set, the pill is
    // hidden entirely rather than leaking the internal version string.
    const rawLabel = activeVersion?.label;
    const versionLabel = (
        typeof rawLabel === 'string'
        && rawLabel.trim() !== ''
        && rawLabel.trim() !== 'New Label'
    ) ? rawLabel.trim() : null;

    return (
        <div className="ae-view ae-questionnaire" ref={containerRef}>
            <div className="ae-progress-section">
                <div className="ae-header-bar">
                    {versionLabel ? (
                        <div className="ae-version-pill" title={versionLabel}>
                            <span className="pill-icon" aria-hidden="true">📋</span>
                            <span className="pill-label">{versionLabel}</span>
                        </div>
                    ) : <span />}
                    <div className="ae-header-actions">
                        <button
                            className="ae-btn secondary small"
                            onClick={() => {
                                if (window.confirm('다른 분야를 선택하시겠습니까? 진행 중인 내용이 초기화됩니다.')) {
                                    onReselect();
                                }
                            }}
                        >
                            다른 분야 선택
                        </button>
                        <button
                            className="ae-btn secondary small ae-btn-restart"
                            onClick={() => {
                                if (window.confirm('처음부터 다시 시작하시겠습니까? 진행 중인 내용이 초기화됩니다.')) {
                                    onRestart();
                                }
                            }}
                        >
                            처음부터 다시
                        </button>
                    </div>
                </div>
                <ProgressBar current={(currentQuestion?.sortOrder || 1) - 1} total={totalQuestions} />
            </div>

            <div className="ae-question-area">
                {currentQuestion ? (
                    <QuestionRenderer
                        question={currentQuestion}
                        initialAnswer={initialAnswer} // Passed
                        onAnswer={onAnswer}
                        onBack={onBack}
                    />
                ) : (
                    <div className="ae-empty">
                        <p>질문 데이터를 불러올 수 없습니다.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default QuestionnaireFlow;
